var OrderBasket = /*@__PURE__*/ (function () {
    function OrderBasket() {
        this.bundles = [];
        this.portings = [];
        this.basketVoucher = null;
    }
    OrderBasket.prototype.getValid = function () {
        return this.VALID;
    };
    OrderBasket.prototype.setValid = function (valid) {
        this.VALID = valid;
        return this;
    };
    OrderBasket.prototype.getBundles = function () {
        return this.bundles;
    };
    OrderBasket.prototype.addBundle = function (bundle) {
        this.bundles.push(bundle);
        return this;
    };
    OrderBasket.prototype.getPortings = function () {
        return this.portings;
    };
    OrderBasket.prototype.addPortingItem = function (portingItem) {
        this.portings.push(portingItem);
        return this;
    };
    OrderBasket.prototype.getBasketVoucher = function () {
        this.basketVoucher = JSON.parse(window.localStorage.getItem("activeVoucher"));
    };
    return OrderBasket;
}());
export { OrderBasket };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.basket.ts
// module id = null
// module chunks = 